import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Select, Skeleton } from '@mantine/core';
import { HiChevronDown } from 'react-icons/hi2';
import Chart from './Chart';
import { apiGetRaportimetStatusi } from 'services/RaportimetStatusiServices';
import { getData, postData } from '../services/fetch-service';
import isEmpty from 'lodash/isEmpty'


function Charts(props) {
    const { locale } = props;
    const currentYear = new Date().getFullYear();

    const [Status, setStatus] = useState([]);
    const [Statistics, setReportsStatistics] = useState([]);
    const [statusStatistics, setReportsStatusStatistics] = useState([]);
    const [typeSelected, setTypeSelected] = useState(0);
    const [Years, setYears] = useState([]);
    const [yearSectionSelected, setYearSectionSelected] = useState(-1);
    const [yearTypeSelected, setYearTypeSelected] = useState(-1);
    const [statusForType, setStatusForType] = useState(0);
    const [statusForSector, setStatusForSector] = useState(0);
    const [sectorLoader, setSectorLoader] = useState(true);
    const [bussinessTypeLoader, setBussinesTypeLoader] = useState(true);

    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ReportTranslations = useSelector((state) => state.WebsiteLanguage.data.ReportTranslations);
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);

    const [nameLocale, setNameLocale] = useState("");
    
	useEffect(() => {
		if (WebsiteLanguage === 'sq') {
			setNameLocale("nameSq");
		} else if (WebsiteLanguage === 'en') {
			setNameLocale("nameEn");
		} else if (WebsiteLanguage === 'sr') {
			setNameLocale("nameSr");
		} else {
			setNameLocale("nameSq");
		};
	}, [WebsiteLanguage])

    useEffect(() => {
        fetchYears()
    }, [])

	const fetchYears = async () => {
		const response = await getData('Home/GetYearsWithReports');
		setYears(response.data);
	}

    const [latestBussinessTypeRequest, setLatestBussinessTypeRequest] = useState(null);

    const data = {
        viti: `${yearTypeSelected}`,
        statusiId: `${statusForType}`,
        Gjuha: `${WebsiteLanguage}`
    }

    const dataStatus = {
        viti: `${yearSectionSelected}`,
        raportimiId: `${statusForSector}`,
        Gjuha: `${WebsiteLanguage}`
    }

    const ReportStatistics = async (data) => {
            const response = await postData('Home/GetReportsStatisticsAsync', data);
            return response.data;
    }

    useEffect(() => {
        const abortController = new AbortController();
        setLatestBussinessTypeRequest(abortController);
        ReportStatistics(data).then((response) => {
            if (!abortController.signal.aborted) {
                setReportsStatistics(response);
                setBussinesTypeLoader(false);
            }
        })
        return () => {
            abortController.abort();
        };
    }, [locale,yearTypeSelected, statusForType, WebsiteLanguage]);


    useEffect(() => {
        fetchData()
    }, [])

	const fetchData = async () => {
		const response = await getData('Home/GetStatuset');
		setStatus(response.data);
	}

    useEffect(() => {
        if (latestBussinessTypeRequest) {
            latestBussinessTypeRequest.abort();
        }
    }, [locale,yearTypeSelected, statusForType]);

    const [latestSectorRequest, setLatestSectorRequest] = useState(null);


    const ReportStatusStatistics = async (data) => {
        const response = await postData('Home/GetReportsStatusStatisticsAsync', data);
        return response.data;
}
    useEffect(() => {
        const abortController = new AbortController();
        setLatestBussinessTypeRequest(abortController);
        ReportStatusStatistics(dataStatus).then((response) => {
            if (!abortController.signal.aborted) {
                setReportsStatusStatistics(response);
                setSectorLoader(false);
            }
        })
        return () => {
            abortController.abort();
        };
    }, [locale,yearSectionSelected, statusForSector, WebsiteLanguage]);


    const RaportimetList = [
        { key: "1", value: "1", label: `${GeneralTranslations.signal}`},
        { key: "2", value: "2", label: `${GeneralTranslations.interestsConflict}` },
        { key: "3", value: "3", label: `${GeneralTranslations.DeklarimiPasurise}` },
        { key: "4", value: "4", label: `${GeneralTranslations.Other}`}
    ];

    useEffect(() => {
        if (latestSectorRequest) {
            latestSectorRequest.abort();
        }
    }, [locale, statusForSector,yearSectionSelected]);

    const YearSelect = Years.map((y) => ({ 
        key: y.toString(),
        value: y.toString() || '',
        label: y.toString() || '',
    }));

    const StatusList = Status.map((s) =>({
        key: s.id.toString(),
        value: s.id.toString(),
        label: s[nameLocale] || '',
    }))


    const bussinessTypeLabel = Statistics.map((item) => item.nrRaportimeve + ' - ' + item.llojiRaportimitPershrkrimi);
    const bussinessTypeData = Statistics.map((item) => item.nrRaportimeve);

    const statusTypeLabel = statusStatistics.map((item) => item.nrRaportimeveStatusi + ' - ' + item.statusiRaportimit);
    const statusTypeData = statusStatistics.map((item) => item.nrRaportimeveStatusi);

    let placeholderTextYear;
    let placeholderSelectionYear;

    if(yearTypeSelected === -1){
        placeholderTextYear = `${GeneralTranslations.YearListLabel}`
    }

    if(yearSectionSelected === -1){
        placeholderSelectionYear = `${GeneralTranslations.YearListLabel}`
    }
    if (locale === 'sq') {
        placeholderTextYear = `${GeneralTranslations.Year}`;
    } else if (locale === 'en') {
        placeholderTextYear = `${GeneralTranslations.Year}`
    } else if (locale === 'sr') {
        placeholderTextYear = `${GeneralTranslations.Year}`;
    }

    return (
        <div className="charts">
            <div className="charts-header">
                <h1 className="charts-title">{GeneralTranslations.reportStats}</h1>
                <h4 className="charts-subtitle">{GeneralTranslations.seeReportStats}</h4>
            </div>
            <div className="charts-section">
                <div className="chartbox">
                    <h3 className="chartbox-title">{GeneralTranslations.reportNumber}</h3>
                    <div className="select-inputs inputs-btype">
                        <Select
                            placeholder={placeholderTextYear}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                yearTypeSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setYearTypeSelected(-1);
                                } else {
                                    setYearTypeSelected(selectedValue);
                                }
                            }}
                            value={`${yearTypeSelected}`}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={YearSelect}
                        />
                        <Select
                            placeholder={`${GeneralTranslations.status}`}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                statusForType ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setStatusForType(0);
                                } else {
                                    setStatusForType(selectedValue);
                                }
                            }}
                            value={statusForType}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={StatusList}
                        />
                    </div>
                    <div className="chart-apk">
                        {!bussinessTypeLoader ? (
                            <Chart
                                series={bussinessTypeData}
                                customOptions={{ labels: bussinessTypeLabel }}
                                legend="left"
                                height="100%"
                                type="pie"
                            />
                        ) : (
                            <div className="sect-skeleton">
                                <Skeleton className="skeleton-pie" height={380} circle mb="xl" />
                                <div className="skeleton-text">
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="chartbox">
                    <h3 className="chartbox-title">{GeneralTranslations.reportNumberStatus}</h3>
                    <div className="select-inputs inputs-btype">
                        <Select
                            placeholder={placeholderSelectionYear}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                yearSectionSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setYearSectionSelected(-1);
                                } else {
                                    setYearSectionSelected(selectedValue);
                                }
                            }}
                            value={`${yearSectionSelected}`}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={YearSelect}
                        />
                        <Select
                            placeholder={`${GeneralTranslations.LlojiRaportimit}`}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                statusForSector ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setStatusForSector(0);
                                } else {
                                    setStatusForSector(selectedValue);
                                }
                            }}
                            value={statusForSector}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={RaportimetList}
                        />
                    </div>
                    <div className="chart-apk">
                        {!sectorLoader ? (
                            <Chart
                                series={statusTypeData}
                                customOptions={{ labels: statusTypeLabel }}
                                legend="left"
                                height="100%"
                                type="donut"
                            />
                        ) : (
                            <div className="sect-skeleton">
                                <Skeleton className="skeleton-pie" height={380} circle mb="xl" />
                                <div className="skeleton-text">
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(Charts);
